var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5C6 9.33 5.33 10 4.5 10C3.67 10 3 9.33 3 8.5C3 7.67 3.67 7 4.5 7C5.33 7 6 7.67 6 8.5ZM10 9.5H30V7.5H10V9.5ZM6 16.5C6 17.33 5.33 18 4.5 18C3.67 18 3 17.33 3 16.5C3 15.67 3.67 15 4.5 15C5.33 15 6 15.67 6 16.5ZM10 17.5H30V15.5H10V17.5ZM6 24.5C6 25.33 5.33 26 4.5 26C3.67 26 3 25.33 3 24.5C3 23.67 3.67 23 4.5 23C5.33 23 6 23.67 6 24.5ZM10 25.5H30V23.5H10V25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListA);
export default __webpack_public_path__ + "static/media/listA.86dad1678bac0efdc10ed0b27b4ef8ed.svg";
export { ForwardRef as ReactComponent };